import styled, { css } from 'styled-components';
import { blockTokens } from '../../../../tokens/components/Block/tokens';
import { StyledIcon } from '../../../Icon/Icon';

export const BlockHeaderIconWrapper = styled.div`
  align-items: flex-start;
  background-color: ${blockTokens.CoreBackgroundColorTransparent};
  border: 0;
  cursor: pointer;
  display: flex;
  padding: 0;
  position: absolute;
  right: ${blockTokens.CoreSpacingBox};
  top: 50%;
  transform: translateY(-50%);
  max-width: 22px;

  ${({ theme }) =>
    theme.left &&
    css`
      left: ${blockTokens.CoreSpacingBox};
    `}

  ${StyledIcon} > svg {
    transition-duration: 60ms;
    transition-property: all;
    transition-timing-function: ease-in;
    transform: scale(0.75);
    transform-origin: center;
  }

  &:hover {
    text-decoration: none;

    ${StyledIcon} > svg {
      transform: scale(1);
      backface-visibility: hidden;
      perspective: 1000;
      color: ${blockTokens.CoreIconColor};
      text-decoration: none;
      will-change: auto;
    }
  }
`;
